import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { MapScreenSettings } from "../v2/queries/interfacesV2";
export const toObjects = (data: string[]) =>
  data.map((v, i) => ({ label: v, value: i + 1 }));
export const groupOptions = toObjects([
  "dontGroup",
  "direction",
  "hand_over_is_asap",
  "status",
  "driver",
]);
export const sortOptions = toObjects([
  "hand_over_time",
  "distance_to_branch_in_km",
  "daily_receipt_number",
]);

export const defaultOptions: MapScreenSettings = {
  cluster_options: 1,
  sort_options: 1,
  statuses: [7, 4, 9],
  show_orders_assigned_to_courier: true,
  pin_code_check: false,
  item_id: -1,
  merge_formulas: false,
  couriers_can_assign_orders_to_themselves: false,
};

export const settingsAtom = atomWithStorage(
  "mapOrdersSettings",
  defaultOptions
);
const useMapOrdersSettings = () => {
  const atom = useAtom(settingsAtom);
  return atom;
};

export const useSetMapOrdersSettings = () => useSetAtom(settingsAtom);

export default useMapOrdersSettings;
